import { environment } from 'src/environments/environment';
import {appMenu} from './menu.config';

export const appStateConfig = {
  initState: {
    name: environment.appName,
    version: environment.appVersion,
    author: 'We-COM',
    logo: './assets/images/logo.png',
    menu: appMenu,
    header: {
      showTitle: false,
      showLogo: true
    }
  }
};
